import { University } from "@/store/types/universityTypes";
import { motion } from "framer-motion";
import { useState } from "react";
import MarkdownText from "../common/MarkdownText";
import { getUniversityContextLinks } from "@/utils/contextualLinks";

const NewAbout = ({ universityData }: { universityData: University }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      className="mt-[32px]"
    >
      <div className="p-[14px] border border-[#D0C4FF] bg-[#FFFFFF8A] rounded-[12px]">
        <p className="text-sm font-semibold ff_poppins text-primary">
          ABOUT UNIVERSITY
        </p>
        <div
          className={`text-base ff_poppins ${
            !isExpanded ? "line-clamp-4" : ""
          }`}
        >
          <MarkdownText
            content={universityData?.description}
            keywords={getUniversityContextLinks(
              universityData?.college_slug || universityData?.name
            )}
          />
        </div>

        <button
          onClick={() => setIsExpanded(!isExpanded)}
          className="mt-2 text-sm sm:text-base text-primary cursor-pointer font-medium hover:underline ff_poppins"
        >
          {isExpanded ? "View Less" : "View More"}
        </button>
      </div>
    </motion.div>
  );
};
export default NewAbout;
